import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { responsiveCard } from "../../utils/responsive";
import { typographyDefinition } from "../../theme/typography";
import { theme } from "../../theme/css/theme.css";

export const cardStyle = style({
  alignItems: "flex-start",
});

export const iconButtonHeaderStyle = style({
  alignSelf: "flex-start",
  display: "none",
  ...responsiveCard({
    220: {
      display: "block",
    },
  }),
});

export const iconButtonFooterStyle = style({
  alignSelf: "flex-end",
  display: "block",
  ...responsiveCard({
    220: {
      display: "none",
    },
  }),
});

export const titleContainerStyle = style({
  width: "100%",
});

export const titleStyle = recipe({
  base: {
    ...typographyDefinition.bodyS,
  },
  variants: {
    color: {
      default: {
        color: theme.colors.onBackground,
        opacity: 0.5,
      },
      accent: {
        color: theme.colors.primary,
      },
      success: {
        color: theme.colors.success,
      },
    },
  },
});

export const valueContainerStyle = style({
  width: "100%",
});

export const flexGrowStyle = style({
  flexGrow: 1,
});
